import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { NUMBER } from "../../../constants/app-constants";
import RtoInfoLoader from "../../shared/rto-info-loader/component";
import { TITLE_MAPPING } from "./selector";

const EChallanLoader = ({
    factsData = TITLE_MAPPING,
    isVariant = false
}) => {

    const factMapping = factsData.reduce((acc, item) => {
        if (item?.isActive) {
            acc[Object.keys(acc).length] = {
                title: item?.title,
                description: item?.description
            };
        }
        return acc;
    }, {});

    const [fact, setFactData] = useState(factMapping[NUMBER.ZERO]);
    const [intervalCount, setIntervalCount] = useState(NUMBER.ZERO);

    useEffect(() => {
        const interval = window.setInterval(() => {
            if (intervalCount < factsData.length) {
                setFactData(factMapping[intervalCount + NUMBER.ONE]);
                setIntervalCount(intervalCount + NUMBER.ONE);
            } else {
                window.clearInterval(interval);
            }
        }, NUMBER.THREE_THOUSAND);

        return () => {
            window.clearInterval(interval);
        };
    }, [intervalCount, factMapping, factsData.length]);

    return (
        <RtoInfoLoader
            description={fact?.description}
            isVariant={isVariant}
        />
    );
};

EChallanLoader.propTypes = {
    settledChallanCount: PropTypes.string,
    factsData: PropTypes.array,
    isVariant: PropTypes.bool
};

export default EChallanLoader;
